var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import createStyles from './styles';

var config = {};

export default _extends({}, config, {
  styles: createStyles(config)
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-themes/dist/es/idyll/index.js
// module id = 973
// module chunks = 0